import { useContext } from 'react';
import { ExperienceContext, useStore } from '@thd-nucleus/experience-context';
import { useDataModel, params, string, arrayOf, shape } from '@thd-nucleus/data-sources';
import { BuyItAgainProductPod } from '../buyItAgain/BuyItAgainProductPod';
// Shared searchModel dataModel used by components that consume useSearchContext
export const searchModelDataModel = {
  searchModel: params({
    navParam: string(),
    keyword: string(),
    storeId: string(),
  }).shape({
    products: arrayOf(shape({
      itemId: string()
    })),
    metadata: shape({
      contentType: string()
    }),
    // These changes are made for fusion. Currently, skipBuyitAgain is set to true as the feature is disabled.
    // If going to enable BuyitAgain feature, please make changes here as well.
    buyitagain: params({ dataSource: string() })
      .arrayOf(shape((BuyItAgainProductPod.dataModel.product))).skip('skipBuyitagain', true)
  })
};

export const useSearchContext = () => {
  const { customContext } = useContext(ExperienceContext);
  const {
    varnish, variables, isSearch: isSearchPageFromContext, isBrandPage, isBrowse
  } = customContext || {};

  const store = useStore({ varnish, online: false });
  const keyword = customContext?.variables?.keyword || '';
  const nValue = customContext?.variables?.navParam;

  const defaultOptions = {
    variables,
    ssr: true,
    skip: !keyword && !nValue,
  };

  const { data, loading, error } = useDataModel('searchModel', defaultOptions);
  const { searchModel = {} } = data || {};
  const { metadata = {} } = searchModel || {};
  const isCategoryPageFromMetadata = metadata?.contentType === 'categorypage';

  return {
    // Context data
    isSearchPageFromContext,
    isBrandPage,
    isBrowse,
    keyword,
    nValue,
    store,

    // Search model data
    data,
    loading,
    error,
    isCategoryPageFromMetadata,

    // Computed values
    products: data?.searchModel?.products || [],
    itemIds: (data?.searchModel?.products || []).map(({ itemId }) => itemId),
  };
};
